import type { CurrentUser } from '@xfile/shared';
import { useAuth } from './AuthProvider';

/**
 * L'utilisateur est-il SUPERADMIN ? Source UNIQUE de vérité côté SPA pour les
 * affordances réservées au superadmin (console `/admin`, XFILE-07/-09), alignée
 * mot pour mot sur la règle du serveur :
 *
 *   superadmin = rôle `superadmin` (strict — un `admin` ne l'est PAS).
 *
 * L'UI MASQUE (pas seulement désactive) les affordances de console pour tout autre
 * rôle ; le serveur renvoie 403 sur `/api/admin/*` et `SuperadminRoute` ferme aussi
 * l'accès par URL. Centralise le calcul — importer ce helper, ne pas le redupliquer.
 */
export function isSuperadminFor(user: CurrentUser | null): boolean {
  if (user === null) return false;
  return user.role === 'superadmin';
}

/** Variante hook : lit l'utilisateur actif du contexte d'auth. */
export function useIsSuperadmin(): boolean {
  const { user } = useAuth();
  return isSuperadminFor(user);
}
